import { render, staticRenderFns } from "./SportSubscriptionsStatistics.vue?vue&type=template&id=4eabfc60&scoped=true"
import script from "./SportSubscriptionsStatistics.vue?vue&type=script&lang=js"
export * from "./SportSubscriptionsStatistics.vue?vue&type=script&lang=js"
import style0 from "./SportSubscriptionsStatistics.vue?vue&type=style&index=0&id=4eabfc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eabfc60",
  null
  
)

export default component.exports